const time_in_circle = `
  1. What does this graph tell us about the discussion? <br/ > <br />
  2. Were there any students who were tapped in significantly longer than others? <br/ > <br />
  3. Was that because they were talking a lot or spending a lot of time waiting for a chance to contribute? <br/ > <br />
  4. How can we make the conversation more balanced in the future?
`;

const total_tap_ins = `
  1. Was there any type of contribution that was more common than the others? Why do you think that was the case? <br/ > <br />
  2. Was there any type of contribution that we did less often? Why do you think that was the case? <br/ > <br />
  3. Do you think it’s important for us to try and find a better balance? Why or why not?
`;

const bar_chart = `
  1. Were there any students who tapped in a lot more than others? <br/ > <br />
  2. Were they any students who didn’t contribute? How can we encourage everyone to participate next time? <br/ > <br />
  3. Click on any of the types of contributions to filter. Is there anything else you notice?
`;

export default {
  time_in_circle,
  total_tap_ins,
  bar_chart,
};



// WEBPACK FOOTER //
// ./src/app/features/measureLiveDiscussion/reflectionQuestions.js